import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api, useRemote } from '../api';
import { reportClientError } from '../errorHandling';

export function useCatalogFilters() {
  const [params, setParams] = useSearchParams();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const categories = useRemote('/categories');
  const products = useRemote(`/products?${params.toString()}`);

  const update = useCallback((key, value) => {
    setParams(current => {
      const next = new URLSearchParams(current);
      if (value) next.set(key, value);
      else next.delete(key);
      return next;
    });
  }, [setParams]);

  const selectCategory = useCallback(categoryId => {
    update('category', categoryId);
    if (categoryId) {
      api.post(`/categories/${categoryId}/use`)
        .catch(error => reportClientError('Category usage could not be recorded', error));
    }
  }, [update]);

  const reset = useCallback(() => setParams({}), [setParams]);
  const toggleFilters = useCallback(() => setFiltersOpen(current => !current), []);

  return { params, categories, products, filtersOpen, update, selectCategory, reset, toggleFilters };
}